/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { DeviceEventType } from './DeviceEventType';
import {
    DeviceEventTypeFromJSON,
    DeviceEventTypeFromJSONTyped,
    DeviceEventTypeToJSON,
    DeviceEventTypeToJSONTyped,
} from './DeviceEventType';

/**
 * 
 * @export
 * @interface ListDeviceEventsRequest
 */
export interface ListDeviceEventsRequest {
    /**
     * 
     */
    hostname: string;
    /**
     * 
     */
    fromTimestamp?: Date | null;
    /**
     * 
     */
    toTimestamp?: Date | null;
    /**
     * 
     */
    eventTypes?: Array<DeviceEventType> | null;
    /**
     * 
     */
    maxPerType?: number;
}

/**
 * Check if a given object implements the ListDeviceEventsRequest interface.
 */
export function instanceOfListDeviceEventsRequest(value: object): value is ListDeviceEventsRequest {
    if (!('hostname' in value) || value['hostname'] === undefined) return false;
    return true;
}

export function ListDeviceEventsRequestFromJSON(json: any): ListDeviceEventsRequest {
    return ListDeviceEventsRequestFromJSONTyped(json, false);
}

export function ListDeviceEventsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListDeviceEventsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'hostname': json['hostname'],
        'fromTimestamp': json['from_timestamp'] === undefined ? undefined : json['from_timestamp'] === null ? null : (parseDateTime(json['from_timestamp'])),
        'toTimestamp': json['to_timestamp'] === undefined ? undefined : json['to_timestamp'] === null ? null : (parseDateTime(json['to_timestamp'])),
        'eventTypes': json['event_types'] === undefined ? undefined : json['event_types'] === null ? null : ((json['event_types'] as Array<any>).map(DeviceEventTypeFromJSON)),
        'maxPerType': json['max_per_type'] == null ? undefined : json['max_per_type'],
    };
}

export function ListDeviceEventsRequestToJSON(json: any): ListDeviceEventsRequest {
    return ListDeviceEventsRequestToJSONTyped(json, false);
}

export function ListDeviceEventsRequestToJSONTyped(value?: ListDeviceEventsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hostname': value['hostname'],
        'from_timestamp': value['fromTimestamp'] == null ? value['fromTimestamp'] : serializeDateTime(value['fromTimestamp']),
        'to_timestamp': value['toTimestamp'] == null ? value['toTimestamp'] : serializeDateTime(value['toTimestamp']),
        'event_types': value['eventTypes'] == null ? undefined : ((value['eventTypes'] as Array<any>).map(DeviceEventTypeToJSON)),
        'max_per_type': value['maxPerType'],
    };
}

